// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__mYlHO","custom-height":"TextArea_custom-height__oSs11","textarea_input":"TextArea_textarea_input__D2dmh","glow":"TextArea_glow__bvrNE"};